<template>
  <div>
    <PublicShell :igreja="igreja" titulo="Cadastro de Membro" :valido="!!igrejaId" max-width="720px">
      <p class="pub-intro">Preencha seus dados:</p>
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 sm12 lg8>
            <v-text-field light v-model="membro.nome" label="NOME COMPLETO*" single-line outlined color="#00695C" dense hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg4>
            <v-text-field light label="CPF*" color="#00695C" outlined v-mask="'###.###.###-##'" dense hide-details type="tel" v-model="membro.cpf" @change="consultaCPF"></v-text-field>
          </v-flex>

          <v-flex xs12 sm12 lg3>
            <v-text-field type="tel" light v-model="membro.dataNascimento" label="DATA DE NASCIMENTO*" single-line outlined color="#00695C" v-mask="'##/##/####'" dense hide-details></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg3>
            <v-select outlined dense v-model="membro.sexo" :items="sexo" hide-details color="#00695C" label="SEXO*"></v-select>
          </v-flex>
          <v-flex xs12 sm12 lg3>
            <v-text-field light label="WHATSAPP COM DDD*" color="#00695C" type="tel" outlined hide-details v-mask="'(##) #####-####'" dense v-model="membro.telefone"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg3>
            <v-select outlined dense v-model="membro.tipo" :items="tipoMembro" hide-details color="#00695C" label="TIPO*"></v-select>
          </v-flex>

          <v-flex xs12 sm12 lg6>
            <v-text-field light v-model="membro.email" label="E-MAIL" single-line outlined color="#00695C" dense hide-details type="email"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 lg6>
            <v-select outlined dense v-model="membro.estadoCivil" :items="estadoCivil" hide-details color="#00695C" label="ESTADO CIVIL"></v-select>
          </v-flex>

          <!-- Rede/Célula: só aparecem se a igreja já tiver redes cadastradas -->
          <v-flex xs12 sm12 lg6 v-if="redes.length">
            <v-select outlined dense v-model="redeSelecionada" :items="redes" hide-details item-text="nome" item-value="id" color="#00695C" label="REDE" @input="carregaCelulas"></v-select>
          </v-flex>
          <v-flex xs12 sm12 lg6 v-if="redes.length">
            <v-select outlined dense :disabled="!redeSelecionada" v-model="membro.celulaId" :items="celulas" hide-details item-text="nome" item-value="id" color="#00695C" label="CÉLULA"></v-select>
          </v-flex>

          <v-flex xs12 sm12 lg12>
            <v-checkbox v-model="membro.aceiteLgpd" hide-details class="mt-2">
              <template v-slot:label>
                <div>Concordo com o tratamento dos meus dados pessoais para fins de cadastro na igreja.</div>
              </template>
            </v-checkbox>
          </v-flex>
        </v-layout>
      </v-container>

      <v-btn dark depressed block rounded color="#00695C" large class="mt-5" @click="criaMembro">Confirmar Cadastro</v-btn>
    </PublicShell>

    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>Informação</v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <v-container>
            <v-row dense>
              <v-col cols="12" style="text-align: center; padding: 2px;">
                <v-icon left color="success" size="100">check_circle</v-icon>
                <p class="cm-msg">Cadastro efetuado com sucesso!</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="closeDialog">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref="chamaSnackbar" />
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import CpfValidate from '../../componentes/validators/rules/cpf'
import { baseApiUrl } from '@/global'
import Snackbar from '../../componentes/snackbar.vue'
import moment from 'moment'
import axios from 'axios'
import PublicShell from '../../componentes/PublicShell.vue'

export default {
  name: 'CadastroMembro',
  components: { Snackbar, Loading, PublicShell },
  data() {
    return {
      igrejaId: '',
      igreja: {},
      membro: {
        nome: '',
        cpf: '',
        email: '',
        dataNascimento: '',
        estadoCivil: '',
        sexo: '',
        telefone: '',
        tipo: '',
        celulaId: '',
        igrejaId: '',
        aceiteLgpd: null,
      },
      redeSelecionada: '',
      redes: [],
      celulas: [],
      sexo: ['MASCULINO', 'FEMININO'],
      estadoCivil: ['SOLTEIRO(A)', 'CASADO(A)', 'VIÚVO(A)', 'DIVORCIADO(A)', 'RELAÇÃO ESTÁVEL'],
      tipoMembro: ['MEMBRO', 'CONGREGADO'],
      dialog: false,
      isLoading: false,
      fullPage: true,
    }
  },

  mounted() {
    this.igrejaId = this.$route.query.igrejaId || ''
    if (this.igrejaId) this.carregaDados()
  },

  methods: {
    async carregaDados() {
      this.isLoading = true
      try {
        const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.igrejaId } })
        if (response.data) this.igreja = response.data
      } catch (error) {
        this.igrejaId = ''
        this.$refs.chamaSnackbar.snack('#FF5252', 'Link inválido ou igreja não encontrada.', 'ERRO')
      } finally {
        this.isLoading = false
      }
      if (this.igrejaId) this.carregaRedes()
    },

    async carregaRedes() {
      try {
        const response = await axios.post(baseApiUrl + 'Redes/listarPublicasPorTipo', {
          igrejaId: this.igrejaId,
          tipo: 'ADULTO',
        })
        if (response.data) this.redes = response.data
      } catch (error) {
        this.redes = []
      }
    },

    async carregaCelulas() {
      this.membro.celulaId = ''
      this.celulas = []
      if (!this.redeSelecionada) return
      try {
        const response = await axios.post(baseApiUrl + 'Celulas/listarPorRedePublico', null, { params: { redeId: this.redeSelecionada } })
        if (response.data) this.celulas = response.data
      } catch (error) {
        this.celulas = []
      }
    },

    async consultaCPF() {
      const vm = this
      if (!this.membro.cpf) return
      this.isLoading = true
      try {
        const response = await axios.post(baseApiUrl + 'Membros/verificaExistenciaCpfPublico', null, { params: { cpf: this.membro.cpf, igrejaId: this.igrejaId } })
        if (response.data && (response.data.existe === true || response.data.count >= 1)) {
          vm.$refs.chamaSnackbar.snack('#F9A825', 'Já existe um cadastro para o CPF informado. Entre em contato com a administração!', 'ATENÇÃO')
        }
      } catch (error) {
        // silencioso
      } finally {
        this.isLoading = false
      }
    },

    async criaMembro() {
      const vm = this
      if (!this.membro.nome || !this.membro.cpf || !CpfValidate(this.membro.cpf) ||
        !this.membro.dataNascimento || !this.membro.sexo || !this.membro.telefone ||
        !this.membro.tipo || !this.membro.aceiteLgpd) {
        vm.$refs.chamaSnackbar.snack('#F9A825', 'Preencha todos os campos obrigatórios (*) corretamente!', 'ATENÇÃO')
        return
      }

      this.isLoading = true
      const payload = Object.assign({}, this.membro)
      payload.nome = payload.nome.toUpperCase()
      payload.igrejaId = this.igrejaId
      payload.dataIntegracao = moment().format('YYYY-MM-DD') + 'T00:00:00.000Z'
      if (!payload.celulaId) delete payload.celulaId

      try {
        const response = await axios.post(baseApiUrl + 'Membros/salvarPublico', payload)
        if (response.data) this.dialog = true
      } catch (error) {
        vm.$refs.chamaSnackbar.snack('#EF5350', 'Problema ao realizar cadastro, verifique os dados informados e tente novamente.', 'DESCULPE')
      } finally {
        this.isLoading = false
      }
    },

    closeDialog() {
      this.dialog = false
      window.location.reload()
    },
  },
}
</script>

<style scoped>
.pub-intro { color: #5b6b67; margin: 0 0 6px; font-size: .95rem; }
.cm-msg { font-weight: bold; color: #00695C; font-size: 17px; }
</style>
